import React from 'react';

/**
 * Loading spinner component - matches original AngularJS loader exactly
 * Shows animated bouncing dots while content is loading
 */
export default function Loader({ show }) {
  if (!show) return null;

  return (
    <div className="loader" style={{ display: 'block' }}>
      <div className="spinner">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
    </div>
  );
}
